import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RankingModalComponent } from 'src/app/components/selected/ranking-modal/ranking-modal.component';
import { ShowedModalComponent } from 'src/app/components/selected/showed-modal/showed-modal.component';
import { ProductApiService } from 'src/app/services/api/product-api.service';

@Component({
  selector: 'app-selected-page',
  templateUrl: './selected-page.component.html',
  styleUrls: ['./selected-page.component.scss'],
})
export class SelectedPageComponent implements OnInit {
  currentDate = new Date();

  constructor(private dialog: MatDialog, private api: ProductApiService) {}

  ngOnInit(): void {
    this.findList();
    this.findSeller();
  }

  openDialog(data: any) {
    this.dialog.open(ShowedModalComponent, {
      data: data,
      panelClass: 'app-dialog',
      width: '800px',
    });
  }

  openRanking() {
    this.dialog.open(RankingModalComponent, {
      data: this.seller,
      panelClass: 'app-dialog',
      width: '842px',
    });
  }

  loading = false;
  list: any = [];
  async findList() {
    try {
      this.loading = true;
      const r = await this.api.findSelected();
      this.list = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  seller: any = [];
  async findSeller() {
    try {
      this.loading = true;
      const r = await this.api.findSeller();
      this.seller = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
